export default __webpack_public_path__ + "static/Image 43-db526188950d125ea40ae85f38059b88.png";